// types
import { createSlice } from "@reduxjs/toolkit";
import i18n from '@/i18n';

const initialState = localStorage.getItem("lang") || "en";

// ==============================|| SLICE - MENU ||============================== //

const lang = createSlice({
  name: "lang",
  initialState,
  reducers: {
    SET_LANG: (state, action) => {
      i18n.changeLanguage(action.payload);
      localStorage.setItem("lang", action.payload);
      return action.payload;
    },
  },
});

export default lang.reducer;

export const { SET_LANG } = lang.actions;
